import { Route, Routes } from 'react-router-dom';
import { SideNav } from 'src/common/components/SideNav';

import { Codes, Listings, Users, Waitlist } from './components';

const MENU = [
  { title: 'Invite Codes', url: '/app/citasmedicas', icon: 'hash' },
  { title: 'Waitlist', url: '/app/citasmedicas/waitlist', icon: 'mail' },
  { title: 'Listings', url: '/app/citasmedicas/listings', icon: 'building-2' },
  { title: 'Users', url: '/app/citasmedicas/users', icon: 'users' },
];

export const Citasmedicas: React.FC = () => (
  <div className="flex h-full">
    <SideNav items={MENU} />
    <div className="flex-1 h-full overflow-hidden">
      <Routes>
        <Route path="/" element={<Codes />} />
        <Route path="/waitlist" element={<Waitlist />} />
        <Route path="/listings" element={<Listings />} />
        <Route path="/users" element={<Users />} />
      </Routes>
    </div>
  </div>
);
